import { Fade } from "react-awesome-reveal";

import Bg from "./assets/images/jpg/bg.jpg";

import { Navi } from "./Navi";

export const Header = () => {
  return (
    <header id="header">
      {/* Navigator */}
      <Navi />
      {/* Top */}
      <div
        style={{
          backgroundImage: `url(${Bg}`,
          backgroundSize: "cover",
          height: "100vh",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div>
          <div
            className="fw-bold text-light text-center"
            style={{
              fontSize: "3vmax",
              textShadow: "black 2px 2px 4px",
              margin: "110px 0px 130px",
            }}
          >
            <Fade triggerOnce delay={360}>
              <div className="mb-3">
                <span>システム開発・ツール開発</span>
              </div>
              <div>
                <span className="border-top pt-2">
                  業務の手助け、イメージを形にする。
                </span>
              </div>
            </Fade>
          </div>
          <div className="text-center pt-5">
            <Fade triggerOnce delay={900}>
              <a href="#service">
                <button className="btn btn-outline-warning btn-lg">
                  サービスを見る
                </button>
              </a>
            </Fade>
          </div>
        </div>
      </div>
    </header>
  );
};
